<template>
	<div>
		<div class="font-weight-bold text-lg text-gray-800">
			<span @click="showDetailOrders" class="cursor-pointer">
				{{ data.customer_data.name }}
			</span>
		</div>
		<div class="text-sm text-gray-600">
			<small>
				{{ data.customer_data.email }}
			</small>
		</div>
		<div class="text-sm text-gray-600">
			<small>
				{{ data.customer_data.phone }}
			</small>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomerColumn',
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {};
	},
	methods: {
		showDetailOrders() {
			this.$emit('show-detail-orders', this.data);
		},
	},
};
</script>
